import React, {useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import Styles from "../sys-site/index.module.css";
import {Card, Menu} from "antd";
import Currency from "./currency";
import {MenuInfo} from "rc-menu/lib/interface";
import DealerNature from "./dealerNature";
import Express from "./express";
import SalesArea from "./salesArea";
import Country from "./country";
import SalesTaxGroup from "./salesTaxGroup";
import DealerGroup from "./dealerGroup";
import OrderType from "./orderType";
import Group from "./group";

const siteMap: { [key: string]: any } = {
    orderType: OrderType,
    currency: Currency,
    dealerGroup: DealerGroup,
    salesTaxGroup: SalesTaxGroup,
    country: Country,
    salesArea: SalesArea,
    dealerNature: DealerNature,
    express: Express,
    group: Group
}

export default function SysBaseData() {

    const [selectedKey, setSelectedKey] = useState('orderType')

    function onClick({key}: MenuInfo) {
        setSelectedKey(key.toString())
    }

    const ContentElement = siteMap[selectedKey]

    return (
        <PageHeaderLayout>
            <Card>
                <div className={Styles.container}>
                    <Menu style={{width: 256}} mode="inline" selectedKeys={[selectedKey]} onClick={onClick} items={[
                        {label: '订单类型', key: 'orderType'},
                        {label: '币种', key: 'currency'},
                        {label: '客户组', key: 'dealerGroup'},
                        {label: '销售税组', key: 'salesTaxGroup'},
                        {label: '国家', key: 'country'},
                        {label: '销售地区', key: 'salesArea'},
                        {label: '客户性质', key: 'dealerNature'},
                        {label: '快递', key: 'express'},
                        {label: '集团', key: 'group'},
                    ]}/>
                    <div className={Styles.pageContainer}>
                        <ContentElement/>
                    </div>
                </div>
            </Card>
        </PageHeaderLayout>
    )
}